// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum SceneType {
	Unknown = 0,
	Crosswalk = 1,
	Highway = 2,
	Intersection = 3,
	ParkingLot = 4,
	Ramp = 5,
	Street = 6,
	Urban = 7,
	WorkZone = 8,
}

export const SceneTypeDisplayNames: { [key in keyof typeof SceneType]?: string} = {
	"Unknown": "Unknown",
	0 : "Unknown",
	"Crosswalk": "Crosswalk",
	1 : "Crosswalk",
	"Highway": "Highway",
	2 : "Highway",
	"Intersection": "Intersection",
	3 : "Intersection",
	"ParkingLot": "ParkingLot",
	4 : "ParkingLot",
	"Ramp": "Ramp",
	5 : "Ramp",
	"Street": "Street",
	6 : "Street",
	"Urban": "Urban",
	7 : "Urban",
	"WorkZone": "WorkZone",
	8 : "WorkZone",
}

export const getSceneTypeDisplayName = (key: SceneType | (keyof typeof SceneType & string)) => {
	return SceneTypeDisplayNames[key];
}

